import { createAction, props } from "@ngrx/store";
import { cardDetailResModel } from "../models/cardBalanceResponse.model";
import { userFavoritesResModel, virtualCardsResModel } from "./models/storage-model";

export const loadUserFavorites = createAction(
    "[Favorite Operations] Load User Favorites",
);

export const removeItemsFromUI = createAction(
    "[Favorite Operations - User Interface] Remove Items"
);

export const deleteFavoriteItem = createAction(
    "[Favorite Operations] Delete Item",
    props<{favId:string}>()
);

export const upsertFavoriteItem = createAction(
    "[Favorite Operations] Upsert Item",
    props<{favorite:string, description:string, favoriteType:string, typeDescription:string}>()
);

export const upsertCardBalance = createAction(
    "[Favorite Operations] Upsert Balance",
    props<{alias: virtualCardsResModel["alias"] | userFavoritesResModel["favorite"]}>()
);

export const CardBalanceAdded = createAction(
    "[Favorite Operations] Balance Upserted",
    props<{balance:cardDetailResModel}>()
);

export const FavoriteItemAdded = createAction(
    "[Favorite Operations] Item Upserted",
    props<{favoriteItem:userFavoritesResModel}>()
);

export const FavoritesLoaded = createAction(
    "[Favorite Operations] Favorites Loaded",
    props<{favorites:userFavoritesResModel[]}>()
)

export const CardsLoaded = createAction(
    "[Favorite Operations] Cards Loaded",
    props<{cards:virtualCardsResModel[]}>()
)